import React from "react"
import PropTypes from "prop-types"
import { withStyles } from "@material-ui/core/styles"
import Drawer from "@material-ui/core/Drawer"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import HamburgerIcon from "./HamburgerIcon"
import { Link } from "gatsby"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { logout } from "../state/actions/auth"
import { connect } from "react-redux"
import ListItemIcon from "@material-ui/core/ListItemIcon"
import ListItemText from "@material-ui/core/ListItemText"

// Styles
import "../styles/components/navDrawer.scss"

// Icons
import {
  FaHome,
  FaDoorOpen,
  FaDoorClosed,
  FaDumbbell,
  FaUtensils,
  FaUserNinja,
  FaEdit,
} from "react-icons/fa"

const styles = {
  listItem: {
    color: "white",
  },
  list: {
    width: "100%",
  },
  paper: {
    background: "#192024",
    fontSize: "1.2rem",
  },
}

class TemporaryDrawer extends React.Component {
  state = {
    top: false,
    left: false,
    bottom: false,
    right: false,
  }

  toggleDrawer = (side, open) => () => {
    this.setState({
      [side]: open,
    })
  }

  render() {
    const { classes } = this.props
    const sideList = (
      <div>
        <div className={classes.list}>
          <div>
            <StaticQuery
              query={graphql`
                query {
                  logo: file(relativePath: { eq: "logoNew.png" }) {
                    childImageSharp {
                      fixed(width: 157) {
                        ...GatsbyImageSharpFixed
                      }
                    }
                  }
                }
              `}
              render={data => (
                <div
                  style={{
                    alignSelf: `left`,
                    width: `200px`,
                    height: `auto`,
                    margin: 25,
                  }}
                >
                  <Img
                    fixed={data.logo.childImageSharp.fixed}
                    style={{ display: "block", margin: "auto" }}
                  />
                </div>
              )}
            />
          </div>
          <List>
            {this.props.isLoggedIn ? (
              <>
                <Link to="/admin/">
                  <ListItem button>
                    <ListItemIcon className="navDrawer__icon">
                      <FaUserNinja />
                    </ListItemIcon>
                    <ListItemText
                      primary="Admin Panel"
                      className="navDrawer__link"
                    />
                  </ListItem>
                </Link>

                <Link to="/app/dashboard">
                  <ListItem button>
                    <ListItemIcon className="navDrawer__icon">
                      <FaHome />
                    </ListItemIcon>
                    <ListItemText
                      primary="Dashboard"
                      className="navDrawer__link"
                    />
                  </ListItem>
                </Link>
                <Link to="/app/workout">
                  <ListItem button>
                    <ListItemIcon className="navDrawer__icon">
                      <FaDumbbell />
                    </ListItemIcon>
                    <ListItemText
                      primary="Workout Schedule"
                      className="navDrawer__link"
                    />
                  </ListItem>
                </Link>
                <Link to="/app/meal">
                  <ListItem button>
                    <ListItemIcon className="navDrawer__icon">
                      <FaUtensils />
                    </ListItemIcon>
                    <ListItemText
                      primary="Meal Plan"
                      className="navDrawer__link"
                    />
                  </ListItem>
                </Link>
                <Link to="/app/dashboard/edit-profile">
                  <ListItem button>
                    <ListItemIcon className="navDrawer__icon">
                      <FaEdit />
                    </ListItemIcon>
                    <ListItemText
                      primary="Edit Profile"
                      className="navDrawer__link"
                    />
                  </ListItem>
                </Link>
                <ListItem button onClick={this.props.logout}>
                  <ListItemIcon className="navDrawer__icon">
                    <FaDoorClosed className="navdrawer__logout" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Logout"
                    className="navDrawer__link navdrawer__logout"
                  />
                </ListItem>
              </>
            ) : (
              <>
                <Link to="/">
                  <ListItem button>
                    <ListItemIcon className="navDrawer__icon">
                      <FaHome />
                    </ListItemIcon>
                    <ListItemText primary="Home" className="navDrawer__link" />
                  </ListItem>
                </Link>
                <Link to="/app">
                  <ListItem button>
                    <ListItemIcon className="navDrawer__icon">
                      <FaDoorOpen />
                    </ListItemIcon>
                    <ListItemText primary="Login" className="navDrawer__link" />
                  </ListItem>
                </Link>
              </>
            )}
          </List>
        </div>
      </div>
    )

    return (
      <div>
        <div className="hamburgerIcon">
          <HamburgerIcon
            onClickHandler={this.toggleDrawer("right", true)}
            style={{ cursor: "pointer" }}
            menuOpen={this.state.right}
          />
          <Drawer
            classes={{ paper: classes.paper }}
            anchor="left"
            open={this.state.right}
            onClose={this.toggleDrawer("right", false)}
          >
            <div
              tabIndex={0}
              role="button"
              onClick={this.toggleDrawer("right", false)}
              onKeyDown={this.toggleDrawer("right", false)}
            >
              {sideList}
            </div>
          </Drawer>
        </div>
      </div>
    )
  }
}

TemporaryDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
}

const mapStateToProps = state => {
  return {
    isLoggedIn: state.isLoggedIn,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    logout: () => dispatch(logout()),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(TemporaryDrawer))
